//
// A random number generator class
// Uses a linear congruential generator using GCC's constants
//
var useOldRandomNumberConstants = false;
// The constructor
export var tbRandom = function (seed) {
    "use strict";
    if (useOldRandomNumberConstants) {
        // This version does not work correctly because JavaScript does not support 64-bit integers
        this.m = 0x80000000; // 2**31;
        this.a = 1103515245;
        this.c = 12345;
    }
    else {
        this.m = 4294967296; // 2**32;
        this.a = 1664525;
        this.c = 1013904223;
    }
    if (seed === undefined) {
        this.state = Math.floor(Math.random() * (this.m - 1));
    }
    else {
        this.state = seed;
    }
};
// returns integer in range [0,2^31> (but with weak randomness in lower bits). Don't use directly
tbRandom.prototype._next = function () {
    "use strict";
    this.state = (this.a * this.state + this.c) % this.m;
    return this.state;
};
// returns a clone of the object
tbRandom.prototype.clone = function () {
    "use strict";
    var res = new tbRandom();
    res.m = this.m;
    res.a = this.a;
    res.c = this.c;
    res.state = this.state;
    return res;
};
// returns real in range [0,n>
tbRandom.prototype.random = function (n) {
    "use strict";
    var nn = 1;
    if (n !== undefined) {
        nn = n;
    }
    return nn * (this._next() / this.m);
};
// returns integer in range [0,n]
tbRandom.prototype.iRandom = function (n) {
    "use strict";
    var nn = 1;
    if (n !== undefined) {
        nn = n;
    }
    return Math.floor(this.random(nn + 1));
};
// returns real in range [n1,n2>
tbRandom.prototype.randomRange = function (n1, n2) {
    "use strict";
    return n1 + this.random(n2 - n1);
};
// returns integer in range [n1,n2]
tbRandom.prototype.iRandomRange = function (n1, n2) {
    "use strict";
    return n1 + this.iRandom(n2 - n1);
};
// Returns randomly one of the arguments
tbRandom.prototype.choice = function () {
    "use strict";
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length === 0) {
        return 0;
    }
    return args[this.iRandomRange(0, arguments.length - 1)];
};
// We define one global random number generator
export var defaultRandom = new tbRandom();
